import { createSelector } from 'reselect';
import { ENetworkRequestStatus } from 'services/BackendApi';
import { IInternalUserDomain } from './model';

export const domainSelector = (state: any): IInternalUserDomain => state.internalUser;

export const internalUserSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.internalUser
);

export const internalUserCreateRequestSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.request.create
);

export const internalUserGetRequestSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.request.get
);

export const internalUserUpdateRequestSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.request.update
);

// Assigned Destinations selectors
export const assignedDestinationsSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.assignedDestinations
);

export const originalUserTypeSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.originalUserType
);

export const assignedDestinationsGetRequestSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.request.getAssignedDestinations
);

export const assignedDestinationsUpdateRequestSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.request.updateAssignedDestinations
);

export const isAssignedDestinationsLoadingSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => domain.request.getAssignedDestinations === ENetworkRequestStatus.PENDING
);

// Combined loading state for edit page (user + destinations both loading)
export const isEditPageLoadingSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) =>
    domain.request.get === ENetworkRequestStatus.PENDING ||
    domain.request.getAssignedDestinations === ENetworkRequestStatus.PENDING
);

// Check if destinations have changed from original (for dirty state tracking)
export const hasDestinationsChangedSelector = createSelector(
  domainSelector,
  (domain: IInternalUserDomain) => {
    const current = [...domain.assignedDestinations].sort();
    const original = [...domain.originalAssignedDestinations].sort();
    if (current.length !== original.length) return true;
    return current.some((code, index) => code !== original[index]);
  }
);
